function ssnMask(value) {
  let len;
  let val;
  let result;
  if (value) {
    val = value.toString().replace(/\D/g, '');
    len = val.length;

    if (len <= 3) {
      result = `${val.substr(0, 3)}`;
    }
    if (len > 3 && len <= 5) {
      result = `${val.substr(0, 3)}-${val.substr(3, 5)}`;
    }
    if (len > 5) {
      result = `${val.substring(0, 3)}-${val.substring(3, 5)}-${val.substring(5, 9)}`;
    }
  }

  return result;
}
export default ssnMask;
